import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

const MAXIMUM_ACCOUNT_COUNT = 100;

interface IGetAccountListUrlProps {
  customerId: string;
}

const DefaultAccountListListParams = {
  $top: MAXIMUM_ACCOUNT_COUNT,
  $skip: '0',
  $count: 'true',
  $select: 'Id',
  $orderby: 'Name asc',
};

export interface IFetchAccountListProps extends IGetAccountListUrlProps {
  ccToken: string;
  params?: any;
}

function getAccountListUrl({
  customerId,
}: IGetAccountListUrlProps) {
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts`;
}

export function fetchAccountList({
  customerId,
  ccToken,
  params = DefaultAccountListListParams,
}: IFetchAccountListProps): Promise<any> {
  const url = getAccountListUrl({ customerId });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
    params,
  } as AxiosRequestConfig);
}
